import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#007C84",
      dark: "#016268",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#FF7900",
      contrastText: "#ffffff",
    },
    background: {
      default: "#F7FAFC",
      paper: "#ffffff",
    },
    text: {
      primary: "#0F172A",
      secondary: "#64748B",
    },
    divider: "#E2E8F0",
  },
  typography: {
    fontFamily: "'Plus Jakarta Sans', 'Outfit', sans-serif",
    button: {
      fontWeight: 600,
      textTransform: "none",
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          fontWeight: 600,
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
        containedPrimary: {
          background: "linear-gradient(135deg, #007C84, #016268)",
          "&:hover": {
            background: "linear-gradient(135deg, #016268, #014f54)",
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#007C84",
          backgroundImage: "linear-gradient(135deg, #007C84, #016268)",
          boxShadow: "0 2px 8px rgba(0,124,132,0.18)",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: "1px solid #E2E8F0",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          "&.Mui-selected": {
            backgroundColor: "rgba(0,124,132,0.08)",
            borderLeft: "3px solid #007C84",
            color: "#007C84",
            "&:hover": {
              backgroundColor: "rgba(0,124,132,0.12)",
            },
          },
          "&:hover": {
            backgroundColor: "rgba(0,124,132,0.06)",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 12,
            "&.Mui-focused fieldset": {
              borderColor: "#007C84",
            },
          },
          "& label.Mui-focused": {
            color: "#007C84",
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: "0 1px 4px rgba(15,23,42,0.08)",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
  },
});

export default theme;
